import Image from 'next/image';
import { SkeletonLoader } from '../../shared/skeleton-loader/skeleton-loader';
import { Logo } from '../../ui/icons/icons';
import ImageWithFallback from '@/src/features/ui/image/image-with-fallback';

export const RecourseLoader = () => {
  return (
    <>
      <div className="flex w-full flex-col items-center gap-5">
        <Logo className={'logo'} width={198} height={36} data-testid="logo" />
        <ImageWithFallback src="/assets/recourse/redirect-ok.gif" width={50} height={50} alt={'hangikredi'} />
        <SkeletonLoader type="image" className="h-[33px] w-[195px]" />
      </div>
      <div className="mt-[93px] flex w-full flex-col items-center gap-3 px-[34px] md:mt-[100px]">
        <SkeletonLoader className="h-6 w-[149px]" />
        <SkeletonLoader className="h-[72px] w-[292px]" />
      </div>
    </>
  );
};
